import createLocationModel, { prop } from './lib/create_location_model';

export default createLocationModel({
  modelName: 'ChannelsAdmin',
  properties: {
    section: prop(String),
  },

  statics: {
    breadcrumb: 'Channels',
    statics: {
      create({ section } = {}) {
        return new this({ section });
      },
    },
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/location/channels_admin.js